import { c as _c } from "react/compiler-runtime";
import React from "react";
import { useWidgetSelector } from "../../../store/store";
import { State } from "../../../store/state";
import { ShareType } from "../../../types/Enums";
import { calculateDonationBreakdown } from "../../../utils/donationCalculations";
import styles from "./DonationSummary.module.scss";
export interface DonationSummaryText {
  single_donation_text: string;
  monthly_donation_text: string;
  smart_distribution_title: string;
  operations_summary_label: string;
  total_label: string;
}
export const DonationSummary: React.FC<{
  text: DonationSummaryText;
}> = t0 => {
  const $ = _c(54);
  const {
    text
  } = t0;
  const donation = useWidgetSelector(_temp);
  const layoutCauseAreas = useWidgetSelector(_temp2);
  let t1;
  if ($[0] !== layoutCauseAreas) {
    t1 = layoutCauseAreas || [];
    $[0] = layoutCauseAreas;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const causeAreas = t1;
  const {
    selectionType,
    causeAreaAmounts: t2,
    orgAmounts: t3,
    causeAreaDistributionType: t4,
    selectedCauseAreaId,
    recurring,
    operationsPercentageModeByCauseArea: t5,
    operationsPercentageByCauseArea: t6,
    smartDistributionTotal: t7,
    globalOperationsEnabled: t8,
    globalOperationsPercentage: t9,
    operationsConfig
  } = donation;
  let t10;
  if ($[2] !== t2) {
    t10 = t2 === undefined ? {} : t2;
    $[2] = t2;
    $[3] = t10;
  } else {
    t10 = $[3];
  }
  const causeAreaAmounts = t10;
  let t11;
  if ($[4] !== t3) {
    t11 = t3 === undefined ? {} : t3;
    $[4] = t3;
    $[5] = t11;
  } else {
    t11 = $[5];
  }
  const orgAmounts = t11;
  let t12;
  if ($[6] !== t4) {
    t12 = t4 === undefined ? {} : t4;
    $[6] = t4;
    $[7] = t12;
  } else {
    t12 = $[7];
  }
  const causeAreaDistributionType = t12;
  let t13;
  if ($[8] !== t5) {
    t13 = t5 === undefined ? {} : t5;
    $[8] = t5;
    $[9] = t13;
  } else {
    t13 = $[9];
  }
  const operationsPercentageModeByCauseArea = t13;
  let t14;
  if ($[10] !== t6) {
    t14 = t6 === undefined ? {} : t6;
    $[10] = t6;
    $[11] = t14;
  } else {
    t14 = $[11];
  }
  const operationsPercentageByCauseArea = t14;
  const smartDistributionTotal = t7 === undefined ? 0 : t7;
  const globalOperationsEnabled = t8 === undefined ? false : t8;
  const globalOperationsPercentage = t9 === undefined ? 5 : t9;
  let t15;
  if ($[12] !== causeAreaAmounts || $[13] !== causeAreaDistributionType || $[14] !== causeAreas || $[15] !== globalOperationsEnabled || $[16] !== globalOperationsPercentage || $[17] !== operationsConfig || $[18] !== operationsPercentageByCauseArea || $[19] !== operationsPercentageModeByCauseArea || $[20] !== orgAmounts || $[21] !== selectedCauseAreaId || $[22] !== selectionType || $[23] !== smartDistributionTotal || $[24] !== text.operations_summary_label || $[25] !== text.smart_distribution_title) {
    bb0: {
      const summaryItems = [];
      if (selectedCauseAreaId === -1 && smartDistributionTotal > 0) {
        const operationsAmount = globalOperationsEnabled ? Math.round(smartDistributionTotal * globalOperationsPercentage / 100) : 0;
        summaryItems.push({
          id: -1,
          name: text.smart_distribution_title,
          amount: smartDistributionTotal - operationsAmount,
          orgs: []
        });
        if (operationsAmount > 0 && operationsConfig?.operationsCauseAreaId !== undefined) {
          summaryItems.push({
            id: operationsConfig.operationsCauseAreaId,
            name: text.operations_summary_label,
            amount: operationsAmount,
            orgs: []
          });
        }
        t15 = {
          summaryItems,
          sum: smartDistributionTotal
        };
        break bb0;
      }
      const breakdown = calculateDonationBreakdown(causeAreaAmounts, orgAmounts, causeAreaDistributionType, operationsPercentageModeByCauseArea, operationsPercentageByCauseArea, causeAreas, selectionType || "single", selectedCauseAreaId, globalOperationsEnabled, globalOperationsPercentage, operationsConfig?.excludedCauseAreaIds || [], operationsConfig?.operationsCauseAreaId, smartDistributionTotal);
      const hasCombinedSmartDistribution = selectionType === "multiple" && smartDistributionTotal > 0;
      const displayedBreakdown = hasCombinedSmartDistribution ? calculateDonationBreakdown(causeAreaAmounts, orgAmounts, causeAreaDistributionType, operationsPercentageModeByCauseArea, operationsPercentageByCauseArea, causeAreas, selectionType, selectedCauseAreaId, globalOperationsEnabled, globalOperationsPercentage, operationsConfig?.excludedCauseAreaIds || [], operationsConfig?.operationsCauseAreaId) : breakdown;
      if (hasCombinedSmartDistribution) {
        const directAmount = Object.values(displayedBreakdown.causeAreaAmounts).reduce(_temp3, 0);
        summaryItems.push({
          id: -1,
          name: text.smart_distribution_title,
          amount: breakdown.totalAmount - breakdown.operationsAmount - directAmount,
          orgs: []
        });
      }
      causeAreas.forEach(area => {
        const areaAmount = displayedBreakdown.causeAreaAmounts[area.id];
        if (!areaAmount || areaAmount <= 0) {
          return;
        }
        const orgs = [];
        if (causeAreaDistributionType[area.id] === ShareType.CUSTOM) {
          area.organizations.forEach(org => {
            const orgAmount = displayedBreakdown.organizationAmounts[org.id];
            if (orgAmount && orgAmount > 0) {
              orgs.push({
                id: org.id,
                name: org.name,
                amount: orgAmount
              });
            }
          });
        }
        summaryItems.push({
          id: area.id,
          name: area.name,
          amount: areaAmount,
          orgs: orgs.length > 0 ? orgs : undefined
        });
      });
      if (breakdown.operationsAmount > 0 && operationsConfig?.operationsCauseAreaId !== undefined) {
        let t16;
        if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
          t16 = [];
          $[27] = t16;
        } else {
          t16 = $[27];
        }
        let t17;
        if ($[28] !== breakdown || $[29] !== operationsConfig.operationsCauseAreaId || $[30] !== text.operations_summary_label) {
          t17 = {
            id: operationsConfig.operationsCauseAreaId,
            name: text.operations_summary_label,
            amount: breakdown.operationsAmount,
            orgs: t16
          };
          $[28] = breakdown;
          $[29] = operationsConfig.operationsCauseAreaId;
          $[30] = text.operations_summary_label;
          $[31] = t17;
        } else {
          t17 = $[31];
        }
        summaryItems.push(t17);
      }
      let t16;
      if ($[32] !== breakdown || $[33] !== summaryItems) {
        t16 = {
          summaryItems,
          sum: breakdown.totalAmount
        };
        $[32] = breakdown;
        $[33] = summaryItems;
        $[34] = t16;
      } else {
        t16 = $[34];
      }
      t15 = t16;
    }
    $[12] = causeAreaAmounts;
    $[13] = causeAreaDistributionType;
    $[14] = causeAreas;
    $[15] = globalOperationsEnabled;
    $[16] = globalOperationsPercentage;
    $[17] = operationsConfig;
    $[18] = operationsPercentageByCauseArea;
    $[19] = operationsPercentageModeByCauseArea;
    $[20] = orgAmounts;
    $[21] = selectedCauseAreaId;
    $[22] = selectionType;
    $[23] = smartDistributionTotal;
    $[24] = text.operations_summary_label;
    $[25] = text.smart_distribution_title;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  const {
    summaryItems: summaryItems_0,
    sum
  } = t15;
  if (sum === 0) {
    return null;
  }
  const t16 = recurring ? text.monthly_donation_text : text.single_donation_text;
  let t17;
  if ($[35] !== t16) {
    t17 = <div className={styles.header} data-cy="donation-type">{t16}</div>;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== summaryItems_0) {
    t18 = summaryItems_0.map(_temp5);
    $[37] = summaryItems_0;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== t18) {
    t19 = <table className={styles.organizationsList} cellSpacing={0}><tbody>{t18}</tbody></table>;
    $[39] = t18;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== text.total_label) {
    t20 = <td data-cy="summary-total-label">{text.total_label}</td>;
    $[41] = text.total_label;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== sum) {
    t21 = sum.toLocaleString("no-NB");
    $[43] = sum;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] !== t21) {
    t22 = <td data-cy="summary-total-amount">{t21} kr</td>;
    $[45] = t21;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  let t23;
  if ($[47] !== t20 || $[48] !== t22) {
    t23 = <table className={styles.totalTable}><tbody><tr>{t20}{t22}</tr></tbody></table>;
    $[47] = t20;
    $[48] = t22;
    $[49] = t23;
  } else {
    t23 = $[49];
  }
  let t24;
  if ($[50] !== t17 || $[51] !== t19 || $[52] !== t23) {
    t24 = <div className={styles.wrapper} data-cy="donation-summary">{t17}{t19}{t23}</div>;
    $[50] = t17;
    $[51] = t19;
    $[52] = t23;
    $[53] = t24;
  } else {
    t24 = $[53];
  }
  return t24;
};
function _temp(state) {
  return state.donation;
}
function _temp2(state_0) {
  return state_0.layout.causeAreas;
}
function _temp3(total, amount) {
  return total + amount;
}
function _temp4(org_0) {
  return <tr key={org_0.id}><td style={{
      paddingLeft: 40
    }} data-cy={`summary-org-${org_0.id}-name`}>{org_0.name}</td><td data-cy={`summary-org-${org_0.id}-amount`}>{org_0.amount.toLocaleString("no-NB")} kr</td></tr>;
}
function _temp5(item) {
  return <React.Fragment key={item.id}><tr data-cy={item.id === -1 ? "summary-smart-distribution" : `summary-cause-area-${item.id}`}><td data-cy={item.id === -1 ? "summary-smart-distribution-name" : `summary-cause-area-${item.id}-name`}><strong>{item.name}</strong></td><td data-cy={item.id === -1 ? "summary-smart-distribution-amount" : `summary-cause-area-${item.id}-amount`}>{(!item.orgs || item.orgs.length === 0) && `${item.amount.toLocaleString("no-NB")} kr`}</td></tr>{item.orgs && item.orgs.map(_temp4)}</React.Fragment>;
}